import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import getName from "../../../common/helpers/getName";
import { getRecentPlans } from "../../store/recentPlans/actions";

import routing from "../../routing";

import PlanCard from "../PlanCard";

import { StyledRecentPlans, PlanTitle } from "./styles";
import { IStateTree } from "../../store/interfaces";

const RecentPlans = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const recentPlans = useSelector((state: IStateTree) => state.recentPlans);
    useEffect(() => {
        dispatch(getRecentPlans());
    }, []);
    if (!recentPlans) return <StyledRecentPlans />;
    const { plans } = recentPlans;
    return (
        <StyledRecentPlans>
            {plans.map((plan, key) => {
                return (
                    <div key={plan._id}>
                        <PlanTitle to={"/" + (routing.publicPlan + "/" + plan._id)}>
                            {getName(plan.name, intl)}
                        </PlanTitle>
                        <PlanCard tiny plan={plan} index={key} />
                    </div>
                );
            })}
        </StyledRecentPlans>
    );
};

export default RecentPlans;

// 1544213208886